module.exports = __webpack_public_path__ + "img/bottom_right_view_img.e64f5960.png";